import { useState } from "react"
import { useDispatch, useSelector } from "react-redux"
import { addFechasEgresosIncioAction, addFechasEgresosFinalAction } from "../../../ducks/reportesDuck"
import { Grid, MenuItem, FormControl, InputLabel, Select } from "@material-ui/core"
import PickerMod from "../../../global/PickersMod"
import { endMounth, esFechaValida, startMounth } from "../../../utils/FormatFecha"

const CabeceraEgresos = () => {
    const dispatch = useDispatch()
    const { egresosFechaFin, egresosFechaInicio } = useSelector(store => store.reportes)
    const [tipoBusqueda, setTipoBusqueda] = useState("0")
    const handleChange = (event) => {
        setTipoBusqueda(event.target.value)
    }
    const handleChangeFechaIncioMes = (date) => {
        if (!esFechaValida({ date })) {
            return null
        }
        const fechaInicio = startMounth({ date })
        dispatch(addFechasEgresosIncioAction({ FechaIni: fechaInicio }))
    }
    const handleChangeFechaFinMes = (date) => {
        if (!esFechaValida({ date })) {
            return null
        }
        const fechaFin = endMounth({ date })
        dispatch(addFechasEgresosFinalAction({ FechaFin: fechaFin }))
    }
    const handleClickSelecFechaInicio = (date) => {
        if (!esFechaValida({ date })) {
            return null
        }
        dispatch(addFechasEgresosIncioAction({ FechaIni: date }))
    }
    const handleClickSelecFechaFinal = (date) => {
        if (!esFechaValida({ date })) {
            return null
        }
        dispatch(addFechasEgresosFinalAction({ FechaFin: date }))
    }
    return (
        <>
            <Grid container spacing={1} alignItems="center" justifyContent="space-between">
                <Grid item xs={4}>
                    <div>
                        <FormControl variant="outlined" style={{ width: "100%", margin: "1rem" }}>
                            <InputLabel id="lEstatus">Buscar por</InputLabel>
                            <Select
                                labelId="lTipoBusquedaEgreso"
                                id="STipoBusquedaEgreso"
                                name="tipoBusquedaEgreso"
                                value={tipoBusqueda}
                                onChange={handleChange}
                                label="Buscar por"
                            >
                                <MenuItem value="0">
                                    {"Intervalo de fechas"}
                                </MenuItem>
                                <MenuItem value="1">
                                    {"Mes"}
                                </MenuItem>
                            </Select>
                        </FormControl>
                    </div>
                </Grid>
            </Grid>
            <Grid container spacing={1} alignItems="center">
                <Grid item xs={3}>
                    <PickerMod
                        id="fechaIncioEgresos"
                        label="Desde"
                        selectedDate={egresosFechaInicio}
                        setSelectedDate={(tipoBusqueda === "0" ? handleClickSelecFechaInicio : handleChangeFechaIncioMes)}
                        disablePast={false}
                        disableFuture={true}
                        formatFecha={tipoBusqueda === "0" ? "dd/MM/yyyy" : "MM/yyyy"}
                        views={tipoBusqueda === "0" ? ["year", "month", "date"] : ["year", "month"]}
                    />
                </Grid>
                <Grid item xs={3}>
                    <PickerMod
                        id="fechaFinalEgresos"
                        label="Hasta"
                        selectedDate={egresosFechaFin}
                        setSelectedDate={(tipoBusqueda === "0" ? handleClickSelecFechaFinal : handleChangeFechaFinMes)}
                        disablePast={false}
                        disableFuture={tipoBusqueda === "0"}
                        formatFecha={tipoBusqueda === "0" ? "dd/MM/yyyy" : "MM/yyyy"}
                        views={tipoBusqueda === "0" ? ["year", "month", "date"] : ["year", "month"]}
                    />
                </Grid>
            </Grid>
        </>
    )
}
export default CabeceraEgresos